/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ViewAdminWrapper } from "../../components/ManageAdmin/style";
import {
  Heading,
  IconInactive,
  TableWarpper,
  Text,
  IconView
} from "../../components/styledConstants";
import FilterBox from "../../components/common/FilterBox";
import Pagination from "../../components/common/Pagination";
import ItemPerPage from "../../components/common/ItemPerPage";
import TableLoader from "../../components/common/TableLoader";
import Request from "../../utils/Request";
import Config from "../../utils/config";
import {
  getParams,
  fromDateConvert,
  toDateConvert,
  dateConvertWithoutTime,
} from "../../utils/common";
import IconDate from "../../assets/images/IconDate";
import IconActive from "../../assets/images/IconActive";
import { FilterWrapper } from "./style";
import CsvDown from "../../components/ExportFiles/CsvDown";
import PdfDown from "../../components/ExportFiles/PdfDown";

const statusOptions = [
  { value: "", label: "Select Status" },
  { value: "TRUE", label: "Active" },
  { value: "FALSE", label: "Inactive" },
];


const filterForm = [
  { name: "mobileNumber", type: "text", placeholder: "Mobile Number", value: "" },
  {
    icon: <IconDate />,
    name: "fromDate",
    type: "date",
    placeholder: "From Date",
    value: "",
    maxDate: new Date(),
  },
  {
    icon: <IconDate />,
    name: "toDate",
    type: "date",
    placeholder: "To Date",
    value: "",
    maxDate: new Date(),
  },
  { name: "name", type: "text", placeholder: "Name", value: "" },
  // { name: "email", type: "text", placeholder: "Email", value: "" },
  { name: "kitNumber", type: "text", placeholder: "Kit Number", value: "" },
  { name: "orgCode", type: "text", placeholder: "Org Code", value: "" },
  // {
  //   name: "vaFilter",
  //   type: "select",
  //   placeholder: "VA Status",
  //   value: "",
  //   options: statusOptions,
  // },
];

export default function NcmcUserList() {
  const [controls, setControls] = useState([...filterForm]);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [downloadPayload, setDownloadPayload] = useState({});

  const headers = [
  { label: "Name", key: "name" },
  { label: "Mobile", key: "mobileNo" },
  { label: "Name on Aadhaar", key: "aadhaarName" },
  { label: "Registered On", key: "createdAt" },
  { label: "Status", key: "status" },
  { label: "Card Reference No.", key: "cardReferenceNumber" },
  { label: "Product Name", key: "productName" },
  { label: "Created By", key: "createdBy.name" },
  { label: "Org Code", key: "orgCode" },
  { label: "Risk Category", key: "riskCategory" },
];
const tableHeader = [
  {
   name: "Name",
    mobileNo: "Mobile",
    aadhaarName: "Name on Aadhaar",
    createdAt: "Registered On",
    status: "App Access",
    cardReferenceNumber: "Card Reference No.",
    productName: "Product Name",
    createdByName: "Created By", 
    orgCode: "Org Code",
    riskCategory: "Risk Category",
  },
];

const getTableBody = (data) =>
  data.map((user) => ({
     name: user?.name || "-",
    mobileNo: user?.mobileNo || "-",
    aadhaarName: user?.aadhaarName || "-",
    createdAt:
      user?.createdAt
        ? user?.createdAt.split("T")[0] +
          " " +
          user?.createdAt.split("T")[1]?.split(".")?.[0]
        : "-",
    status : user?.status?.toLowerCase() === "active" ? "Yes" : "No",
    cardReferenceNumber: user?.cardReferenceNumber || "-",
    productName: user?.productName || "-",
    createdByName: user?.createdBy?.name || "-",
    orgCode: user?.orgCode || "-",
    riskCategory: user?.riskCategory || "-",
  }));
   const renderCanLogin = (status) => {
  const s = status?.toLowerCase();
  const label = s === "active" ? "YES" : "NO";

  if (s === "active") {
    return (
      <div className="flex flex-center">
        <IconActive width="13" className="align-top mr6" color="#2AC940" />
        <Text size="xsm" fw="medium" color="color10">
          {label}
        </Text>
      </div>
    );
  }

  return (
    <div className="flex flex-center">
      <IconInactive width="12px" className="align-top mr6" />
      <Text size="xsm" fw="medium" color="color4">
        {label}
      </Text>
    </div>
  );
};
   const renderStatus = (data) => {
    const status = data?.toLowerCase();
    switch (status) {
      case "active":
        return (
          <div className="flex flex-center">
            <IconActive width="13" className="align-top mr6" color="#2AC940" />
            <Text size="xsm" fw="medium" color="color10">
              {data}
            </Text>
          </div>
        );
      case "inactive":
        console.log("inactive");
        return (
          <div className="flex flex-center">
            <IconInactive width="12px" className="align-top mr6" />
            <Text size="xsm" fw="medium" color="color4">
              {data}
            </Text>
          </div>
        );
      case "unverified":
        return (
          <div className="flex flex-center">
            <IconInactive width="12px" className="align-top mr6" />
            <Text size="xsm" fw="medium" color="color4">
              {data}
            </Text>
          </div>
        );
      case "suspended":
        return (
          <div className="flex flex-center">
            <IconInactive width="12px" className="align-top mr6" color="color11" />
            <Text size="xsm" fw="medium" color="color11">
              {data}
            </Text>
          </div>
        );
    }
  };
const fetchNcmcList = () => {
    setLoader(true);

    const params = getParams(controls);

    params.pagination = {
      pageNo: currentPage,
      pageSize,
    };

    params.vaFilter = params?.vaFilter?.value || "ALL";
    params.vpaActive = params?.vpaActive?.value ?? null;
    params.upgradeStatus = params?.upgradeStatus?.value ?? null;
    params.userType = "ROLE_NCMC_BASIC_USER";

    if (params.fromDate) {
      params.fromDate = dateConvertWithoutTime(fromDateConvert(params.fromDate));
    }
    if (params.toDate) {
      params.toDate = dateConvertWithoutTime(toDateConvert(params.toDate));
    }
     setDownloadPayload({
    ...params,
    pagination: { pageNo: 1, pageSize: 1000 }, // export all
  });
    const successHandler = (res) => {
      setLoader(false);
      setData(res?.data?.content || []);
      setTotalPages(res?.data?.totalPages || 1);
    };

    const errorHandler = () => setLoader(false);

    const api = new Request("", successHandler, errorHandler, false);
    api.post(Config.apis.admin.NCMC_LIST, params);
  };

  useEffect(() => {
    fetchNcmcList();
  }, [currentPage, pageSize]);

  const onFilterChange = (event, index) => {
    const _controls = [...controls];
    _controls[index].value =
      event instanceof Date || event?.label ? event : event?.target?.value;
    setControls(_controls);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchNcmcList();
  };

  const refreshPage = () => {
    setControls([...filterForm]);
    setCurrentPage(1);
  };

  return (
    <>
     <div className="flex flex-center space-between mb10">
  <Heading size="xxl" color="color7">
    NCMC User List
  </Heading>

  <div className="flex flex-center">
    <div className="mr20">
      <CsvDown
        headers={headers}
        url={Config.apis.admin.NCMC_LIST}
        params={downloadPayload}
        title="CSV"
      />
    </div>

    <PdfDown
      heading="NCMC User List"
      tableHeader={tableHeader}
      getTableBody={getTableBody}
      url={Config.apis.admin.NCMC_LIST}
      params={downloadPayload}
    />
  </div>
</div>


      <ViewAdminWrapper>
        <FilterWrapper>
        <FilterBox
          filterForm={controls}
          onFilterChange={onFilterChange}
          onFilterSubmit={onSearch}
          refreshPage={refreshPage}
          />
        </FilterWrapper>

        <TableWarpper className="mt24">
          <table className="table">
            <thead>
               <tr>
                 <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     Name
                   </Text>
                 </th>
                 <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     Name on Aadhar
                   </Text>
                 </th>
                 <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     Contact
                   </Text>
                 </th>
                 <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     Registered on
                   </Text>
                 </th>
                 <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     App Access
                   </Text>
                 </th>
                 <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     Card Reference No.
                   </Text>
                 </th>
                 <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     Product Name
                   </Text>
                 </th>
                  <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     Created By
                   </Text>
                 </th>
                  <th className="text-left">
                     <Text size="rg" color="color7" fw="medium">
                       Org Code
                     </Text>
                    </th>
                    <th className="text-left">
                     <Text size="rg" color="color7" fw="medium">
                       Risk Category
                     </Text>
                    </th>
                    <th className="text-left">
                      <Text size="rg" color="color7" fw="medium">
                        Action
                      </Text>
                    </th>
                 {/* <th className="text-left">
                   <Text size="rg" color="color7" fw="medium">
                     Action
                   </Text>
                 </th> */}
             </tr>
            </thead>
            <tbody>
              {loader && <TableLoader />}
              {!loader && data.length ? (
                data.map((user, idx) => (
                  <tr key={idx}>
                    <td>
                    <Text size="xsm" color="#828282">
                      {user?.name || "-"}
                    </Text>
                    </td>
                    <td>
                    <Text size="xsm" color="#828282">
                      {user?.aadhaarName || "-"}
                    </Text>
                    </td>
                     <td>
                    <Text size="xsm" color="#828282">
                      {user?.mobileNo || "-"}
                    </Text>
                   </td>
                    <td>
                   <Text size="xsm" color="#828282">
                     {user?.createdAt?.split("T")[0] + " " + user?.createdAt?.split("T")[1]?.split(".")?.[0] ||
                       "-"}
                   </Text>
                  </td>
                    <td>
                    <Text size="xsm" color="#828282">
                       {renderCanLogin(user?.status)}
                    </Text>
                   </td>
                      <td><Text size="xsm" color="#828282">
                      {user?.cardReferenceNumber || "-"}
                    </Text></td>
                      <td>
                    <Text size="xsm" color="#828282">
                      {user?.productName || "-"}
                    </Text>
                   </td>
                   <td>
                    <Text size="xsm" color="#828282">
                      {user?.createdBy?.name || "-"}
                    </Text>
                   </td>
                       <td>
                    <Text size="xsm" color="#828282">
                      {user?.orgCode || "-"}
                    </Text>
                   </td>
                   <td>
                    <Text size="xsm" color="#828282" style={{ textTransform: "uppercase" }}>
                      {user?.riskCategory|| "-"}
                    </Text>
                   </td>
                   <td>
                    <Link to={`/merchant-detail/${user?.id}/ncmc_user`} className="flex flex-center" style={{justifyContent: "center"}}>
                      <IconView />
                    </Link>
                   </td>
                    {/* <td>{item?.vaFilter ? "ACTIVE" : "INACTIVE"}</td>
                    <td>{item?.vpaActive ? "ACTIVE" : "INACTIVE"}</td>
                    <td>{item?.createdAt?.split("T")[0]}</td> */}
                  </tr>
                ))
              ) : (
                !loader && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      No records found
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </TableWarpper>

        <div className="mt24 flex flex-center">
          <ItemPerPage pageSize={pageSize} getPageSize={setPageSize} />
          {totalPages > 1 && (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              getCurrentPageData={setCurrentPage}
            />
          )}
        </div>
      </ViewAdminWrapper>
    </>
  );
}